import { Injectable } from '@angular/core';
import { Tags } from '@app/practice-hub/shared/models/tags';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PracticeHubCategoriesTagsService {
    readonly tags$ = new BehaviorSubject<Tags | null>(null);

    resetTags() {
        this.tags$.next(null);
    }
}
